export default {
  path: 'home',
  name: '概览',
  icon: 'MeetingFilled',
  component: '@/pages/home/index',
  accessKey: '1',
};
